import React, { createContext, useContext, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { UserActionsModal } from "pages/user-settings/UserSettingsModal";
import { useAuth } from "./AuthContext";
import { toast } from "react-toastify";

const UserSettingsContext = createContext();

export const UserSettingsProvider = ({ children }) => {
  // const navigate = useNavigate();
  const { user, handleLoginClick } = useAuth();
  const [isUserActionModalOpen, setIsUserActionModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);

  const handleUserSettingMenuItemClick = async (tab) => {
    if (user) {
      if (user?.role !== "User") {
        toast.dismiss();
        toast.error("Only user role have access");
      } else {
        setIsUserActionModalOpen(true);
        setSelectedTab(tab);
      }
    } else {
      handleLoginClick();
    }
  };

  const handleUserSettingModalClose = () => {
    setIsUserActionModalOpen(false);
    setSelectedTab(null);
    // navigate("/");
  };
  return (
    <UserSettingsContext.Provider
      value={{
        isUserActionModalOpen,
        setIsUserActionModalOpen,
        handleUserSettingMenuItemClick,
        handleUserSettingModalClose,
      }}
    >
      {children}
      <UserActionsModal
        selectedKey={selectedTab}
        handleUserSettingMenuItemClick={handleUserSettingMenuItemClick}
        isOpen={isUserActionModalOpen}
        onClose={handleUserSettingModalClose}
      />
    </UserSettingsContext.Provider>
  );
};

export const useUserSettings = () => {
  const context = useContext(UserSettingsContext);

  if (!context) {
    throw new Error("useUserSettings must be used within an UserSettingsProvider");
  }

  return context;
};
